import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import * as React from 'react';

interface ConfirmationSnackbarProps {
  open: boolean;
  handleClose: () => void;
  type?: 'account' | 'password-reset' | 'reset-code-sent' | 'force-password-change';
}

export default function ConfirmationSnackbar({
  open,
  handleClose,
  type = 'account',
}: ConfirmationSnackbarProps) {
  const getMessage = () => {
    switch (type) {
      case 'password-reset':
        return 'Your password has been successfully reset. You can now log in with your new password.';
      case 'force-password-change':
        return 'Your password has been successfully set. You are now logged in.';
      case 'reset-code-sent':
        return 'If an account exists for that address, we have sent it a password reset code. Please check your inbox and enter the code below.';
      case 'account':
      default:
        return 'Successfully confirmed your account. Please log in!';
    }
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      data-testid="confirmation-snackbar-container"
    >
      <Alert
        onClose={handleClose}
        severity="success"
        variant="filled"
        sx={{ width: '100%' }}
        data-testid="confirmation-alert"
      >
        {getMessage()}
      </Alert>
    </Snackbar>
  );
}
